import React from 'react'
import { Link } from 'react-router-dom'
import mac from "./img/medusa.png"
import web from "./img/medusa.png"
import Image from "../../../../Components/Image"

function Medusa() {
    return (
        <div className=" animated fadeInIn">
            <div id="work_content">
                <div className="work_title">Medusa</div>
                <div className="work_type">SAAS</div>
                <div className="process_title">
                    Overview
                </div>
                <div className="process_text">
                    <p>
                    Medusa is a Fintech solution created in 3LINE LTD. It serves as a centralised terminal management system that manages all remote terminals, institutions and users.
                    </p>
                    <p>
                    It is usueful to institutions who run agency banking services and have multiple POS Terminals in circulation.
                    </p>

                    {/* <a href='https://apps.apple.com/gb/app/oudi/id1571999846' className="work_btn" target='_blank'>Get on the app store</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}
                    <a href='https://medusa.3lineng.com/#/'className="work_btn"  target='_blank'>Visit Website</a>
                </div>
            </div>
            <div id="work_content">
                <div className="process_title">
                    Resources
                </div>
                <div className="process_text">

                    <p>
                        <div className="dev_title">Front End</div>
                        <div className="dev_info"> ReactJs, SASS, Redux.</div>
                    </p>
                </div>
            </div>
            <div id="images">
                <Image src={web} />
            </div>
        </div>
    )
}

export default Medusa